import { isSchoolEventDuplicate } from "./resolveSchoolEvent.js";

const TASK_TYPES = new Set(["task", "prep", "bring"]);
const EVENT_TYPE = "event";
const INFO_TYPE = "info";

/**
 * Group flat extraction events into tasks, events, and info for display.
 * Indices in the original `events` array are preserved via `index` on each item.
 * @param {object[]|null|undefined} events
 * @returns {{ tasks: object[], events: object[], info: object[] }}
 */
export function groupSchoolEmailEvents(events) {
  const tasks = [];
  const datedEvents = [];
  const info = [];

  (events || []).forEach((event, index) => {
    if (isSchoolEventDuplicate(event)) return;
    const withIndex = { ...event, index };
    const actionType = String(event?.action_type || "").toLowerCase();

    if (TASK_TYPES.has(actionType)) {
      tasks.push(withIndex);
      return;
    }
    if (actionType === EVENT_TYPE) {
      datedEvents.push(withIndex);
      return;
    }
    if (actionType === INFO_TYPE) {
      info.push(withIndex);
      return;
    }
    if (event?.date) {
      datedEvents.push(withIndex);
    } else {
      info.push(withIndex);
    }
  });

  return { tasks, events: datedEvents, info };
}
